module.exports = __webpack_public_path__ + "icon-256-library-listing-dataset.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-256-library-listing-dataset.png
// module id = 636
// module chunks = 11